import React from 'react'
import styled from 'styled-components'
import Button from 'components/Button'
import Spacer from 'components/Spacer'

const WalletUnlockButton = ({ handleUnlockClick }) => {
  return (
    <>
      <StyledUnlockButton>
        <Spacer size="lg" />
        <Button onClick={handleUnlockClick} size="mg" text="Unlock Pools" />
      </StyledUnlockButton>
    </>
  )
}

const StyledUnlockButton = styled.div`
  width: 200px;
  margin: auto;
`
export default WalletUnlockButton
